import { ChatApi, PresenceApi, UserApi, VisitorPresenceApi } from 'api'
import config from 'config'
import { AuthParams } from 'types/auth'
import { resolvePresenceAPIBase, resolveWSAPIBase } from 'utils/api'

interface SocketAuthParams {
  access_token: string
}

const HAS_CONSENT_ATTRIBUTE_NAME = 'has_consent' // This is hardcoded as the id for some reason

export const getDefaultAuthParams = (orgId: number): AuthParams => ({
  org_id: orgId,
  client_id: config.CLIENT_ID,
  consent_id: HAS_CONSENT_ATTRIBUTE_NAME
})

export const setUserApiBase = () => {
  const protocol = config.WS_USER_ENV === 'LOCAL'
    ? 'http'
    : 'https'

  UserApi.defaults.baseURL = `${protocol}://${config.WS_USER_BASE}/api`
}

export const setVisitorPresenceApiBase = () => {
  const protocol = config.WS_USER_ENV === 'LOCAL'
    ? 'http'
    : 'https'

  VisitorPresenceApi.defaults.baseURL = `${protocol}://${config.WS_VISITOR_PRESENCE_BASE}/api`
}

export const setPresenceApiBase = (orgId: number) => {
  const protocol = config.WS_USER_ENV === 'LOCAL'
    ? 'http'
    : 'https'

  PresenceApi.defaults.baseURL = `${protocol}://${resolvePresenceAPIBase(orgId)}/api`
}

export const setChatApiBase = (orgId: number) => {
  const protocol = config.WS_USER_ENV === 'LOCAL'
    ? 'http'
    : 'https'

  ChatApi.defaults.baseURL = `${protocol}://${resolveWSAPIBase(orgId)}/api`
}

export const getAuthForChatSocket = (data: SocketAuthParams) => {
  return ChatApi.post('auth', data )
}

export const  getAuthForUserSocket = (data: SocketAuthParams) => {
  return UserApi.post('auth', data )
}

export const  getAuthForPresenceSocket = (data: SocketAuthParams) => {
  return PresenceApi.post('auth', data )
}

export const  getAuthForVisitorPresenceSocket = (data: SocketAuthParams) => {
  return VisitorPresenceApi.post('auth', data )
}
